import React, { useMemo } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  IconButton,
  Button,
} from "@material-ui/core";
import { toast } from "react-toastify";
import { FileCopy } from "@material-ui/icons";
import { format, parseISO } from "date-fns";
import ContentLoader from "react-content-loader";
import { useSelector } from "react-redux";
import { backgroundPaymentMethodStatus, paymentMethodStatus } from "utils/functions";

const handleCopy = (value, message) => {
  navigator.clipboard.writeText(value);
  toast.success(message)
};

const DetailsTable = ({installment}) => {
  const { installmentDetails, loadingInstallmentDetails } = useSelector((state) => state.PaymentPlan);
  const installmentPaid = installment.status.props.children === 'Parcela paga';
  
  const columns = [
    { id: "id", label: "ID" },
    { id: "status", label: "Status" },
    { id: "expirationDate", label: "Data de vencimento"},
    { id: "link", label: "Link"},
    { id: "key", label: "Ação"}
  ];

  const rowsFormated = useMemo(() => {
    return installmentDetails?.map(row => ({
        id: row?.id,
        status: <Status row={row} /> ,
        expirationDate: format(parseISO(row?.expirationDate),  "dd/MM/yyyy 'às' HH:mm"),
        link: <Link row={row} installmentPaid={installmentPaid} />,
        key: (row?.status === 'PixGenerated' && !installmentPaid) && <CopyPix pixKey={row?.pix?.emv} /> 
    }));
  }, [installmentDetails, installmentPaid]);

  return (
      <TableRow>
        <TableCell colSpan={7}>
          {loadingInstallmentDetails ? <Loading />
            :
            <TableContainer>    
              <Table size="small" aria-label="details table">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell
                        key={column.id}
                      >
                        <strong>{column.label}</strong>
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {rowsFormated.map((row, idx) => (
                    <TableRow key={idx}>
                      {columns.map((column) => (
                        <TableCell key={column.id} style={{width: '205px'}}>
                          {row[column.id] || "-"}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          }
        </TableCell>
      </TableRow>    
  );
};

export default DetailsTable;

const Status = ({row}) => {
  const isPaid = row?.status === 'PaymentApproved';
  const typeLabel = row?.boleto ? 'Boleto' : 'Pix'
  const method = isPaid ? typeLabel : '';

  return (
    <div style={{padding: '10px', textAlign: 'center', backgroundColor: backgroundPaymentMethodStatus[row?.status], borderRadius: '100px'}}>
      {`${method} ${paymentMethodStatus[row?.status]}`}
    </div>
  )
}

const Link = ({row, installmentPaid}) => {
  return (
    <>
      <a 
        href={row?.boleto?.url || `${window.location.origin}/pix/${row?.id}`} 
        target="_blank" rel="noopener noreferrer" 
        style={{ color: 'inherit' }}
      >
        {row?.boleto?.url || `${window.location.origin}/pix/${row?.id}`}
      </a>

      {((row?.status === 'BoletoGenerated' || row?.status ===  'PixGenerated') && !installmentPaid) &&
        <Tooltip title="Copiar link">
          <IconButton 
            size="small" 
            color="primary" 
            onClick={() => handleCopy(row?.boleto?.url || `${window.location.origin}/pix/${row?.id}`, 'Link copiado com sucesso')} 
            style={{marginLeft: '20px'}}
          >
            <FileCopy />
          </IconButton>
        </Tooltip>
      }
    </>
  )
}

const CopyPix = ({pixKey}) => {
  return (
    <Button 
      size="small" 
      variant="outlined" 
      color="primary" 
      onClick={() => handleCopy(pixKey, 'Pix copiado com sucesso')} 
      endIcon={<FileCopy />}
    >
      {'COPIAR CÓDIGO DO PIX'}
    </Button>
  )

}

const Loading = () => {
  return (
    <ContentLoader
      width="100%"
      height="110px"
      backgroundColor="#eaeced"
      foregroundColor="#ffffff"
      speed={2}
    >
      <rect x="0" y="0" rx="5" ry="5" width="100%" height="30px" />
      <rect x="0" y="40" rx="5" ry="5" width="100%" height="30px" />
      <rect x="0" y="80" rx="5" ry="5" width="100%" height="30px" />
    </ContentLoader>
  )
}